<template functional>
  <div>
    <h2
      id="title"
      class="wallet-title pt-4 pl-4"
    >
      {{ props.title }}
    </h2>
    <p
      id="text"
      class="wallet-subTitle pl-4"
    >
      {{ props.text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'WalletTextSection',
  functional: true,
  props: {
    title: {
      type: String,
      default: null,
      required: true
    },
    text: {
      type: String,
      default: null,
      required: true
    }
  }
}
</script>
